import { RootState } from "store";

export const sidebarState = (state: RootState) => state.sidebarReducer.isClose;

export const sidebarToggleState = (state: RootState) =>
  state.sidebarReducer.isToggled;

export const isSmallScreen = (state: RootState) =>
  state.sidebarReducer.isSmallScreen;

export const screenSizeState = (state: RootState) =>
  state.sidebarReducer.screenSize;

export const leadState = (state: RootState) => state.leadReducer;

export const taskState = (state: RootState) => state.taskReducer;

export const commentState = (state: RootState) => state.commentsReducer;

export const dropdownLeadState = (state: RootState) =>
  state.dropdownLeadReducer;

export const leadActivityState = (state: RootState) =>
  state.leadActivityReducer;

export const userDetailState = (state: RootState) => state.userDetailReducer;

export const tablesState = (state: RootState) => state.tableStatesReducer;

export const callRecordState = (state: RootState) => state.callRecordReducer;

export const customerDataState = (state: RootState) =>
  state.CustomerDataReducer;

export const projectState = (state: RootState) => state.projectReducer;

export const sourceState = (state: RootState) => state.sourceReducer;

export const usersState = (state: RootState) => state.usersReducer;

export const adminLeadState = (state: RootState) => state.adminleadReducer;

export const adminInventoryState = (state: RootState) =>
  state.adminInventoryReducer;

export const dashboardTaskStats = (state: RootState) =>
  state.dashboardTaskStatsReducer;

export const dashboardLeadStats = (state: RootState) =>
  state.dashboardLeadStatsReducer;

export const dashboardState = (state: RootState) =>
  state.userDashboardStateReducer;

export const dashboardWidgetState = (state: RootState) =>
  state.dashboardWidgetReducer;

export const customerContactState = (state: RootState) => state.contactReducer;

export const companyData = (state: RootState) => state.companyReducer;

export const tokensDataState = (state: RootState) => state.tokenReducer;

export const InventoryDataState = (state: RootState) => state.inventoryReducer;

export const individualInventoryDataState = (state: RootState) =>
  state.individualInventoryReducer;

export const dashboardCardState = (state: RootState) =>
  state.dashboardCardsReducer;

export const staffTargetState = (state: RootState) => state.staffTargetReducer;

export const projectBlockState = (state: RootState) =>
  state.projectBlockReducer;

export const projectPhaseState = (state: RootState) =>
  state.projectPhaseReducer;

export const teamState = (state: RootState) => state.teamReducer;

export const projectAssignmentState = (state: RootState) =>
  state.projectAssignmentReducer;

export const userPermissionState = (state: RootState) =>
  state.userPermissionReducer;

export const userSettingState = (state: RootState) => state.userSettingReducer;

export const userPrimaryDashboardState = (state: RootState) =>
  state.userPrimaryDashboardStateReducer;

export const userDashboardCards = (state: RootState) =>
  state.dashboardCardDataReducer;

export const allActivityState = (state: RootState) => state.allActivityReducer;

export const projectDocumentsState = (state: RootState) =>
  state.projectDocumentRedcuer;

export const salesState = (sate: RootState) => sate.salesSliceReducer;

export const skippedContactState = (state: RootState) =>
  state.skippedContactReducer;
